import { Box, styled } from '@mui/material'

import { unit } from '@hcr/ui'

export const Background = styled(Box)<{ readonly url: string }>`
  background: url(${props => props.url});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-inline: ${unit(-3)};
  padding: ${unit(19)} ${unit(3)} ${unit(3)};
`
